import { useCallback } from 'react';

import useRefState from './useRefState';

export default (initialState?: boolean) => {
  const { ref, setValue, ...refStateParams } = useRefState<boolean>(initialState);

  const enableValue = useCallback(() => {
    setValue(true);
  }, [setValue]);

  const disableValue = useCallback(() => {
    setValue(false);
  }, [setValue]);

  const toggleValue = useCallback(() => {
    setValue(!ref.current);
  }, [ref, setValue]);

  return { ...refStateParams, ref, setValue, enableValue, disableValue, toggleValue };
};
